import React from 'react';
import { Col, Row, Label } from 'reactstrap';
import {
  InfoPrompt,
  PricingPeriodData,
} from '../../../../../constants/masterData';
import { displayValue } from '../../../../TenderOpening/utils/tenderOpeningHelpers';
import { formatDateToDDMMYYYY } from '../../../../../utils/dateformatter';
import { sanitizeHtml } from '../../../../../utils/useSanitize';
import '../../../../../App.css';

const FieldItem = ({ label, value, col = 6 }) => (
  <Col md={6} lg={col}>
    <div className='border-start border-2 border-primary ps-3'>
      <Label className='fw-semibold small text-dark mb-1'>{label}</Label>
      <p className='mb-0 text-dark small'>{displayValue(value)}</p>
    </div>
  </Col>
);

const resolveInfoPromptLabel = parcel => {
  if (parcel?.infoPromptLabel) return parcel.infoPromptLabel;
  const value = parseInt(parcel?.infoPrompt, 10);
  return (
    InfoPrompt[0]?.options?.find(option => option.value === value)?.label ||
    null
  );
};

const resolvePricingPeriodLabel = parcel => {
  if (parcel?.pricingPeriodLabel && parcel.pricingPeriodLabel !== '-') {
    return parcel.pricingPeriodLabel;
  }
  const value = parseInt(parcel?.pricingPeriod, 10);
  return (
    PricingPeriodData[0]?.options?.find(option => option.value === value)
      ?.label || null
  );
};

const ParcelField = ({ parcel }) => {
  const pricingPeriod = parseInt(parcel?.pricingPeriod, 10);
  const indexPrice = parcel?.indexPrice || parcel?.indexPricename;
  const otherIndexPrice =
    parcel?.otherIndexPrice || parcel?.otherIndexPricename;

  return (
    <>
      <Row className='g-3'>
        {parcel.productTypeName ? (
          <FieldItem
            label='Product Type'
            value={parcel.productTypeName}
            col={3}
          />
        ) : null}
        <FieldItem label='Delivery Unit' value={parcel.deliveryUnit} col={3} />
        <FieldItem
          label='Pricing Period'
          value={resolvePricingPeriodLabel(parcel)}
          col={parcel.productTypeName ? 6 : 9}
        />
        <FieldItem label='Index Price Reference' value={indexPrice} col={3} />
        <FieldItem label='Other Index Price' value={otherIndexPrice} col={3} />
        <FieldItem
          label='Information'
          value={resolveInfoPromptLabel(parcel)}
          col={3}
        />
        <Col xs={12}>
          <p className='mb-0 text-muted small'>(whichever is lower)</p>
        </Col>
        <FieldItem
          label='Publish Index Period'
          value={formatDateToDDMMYYYY(parcel?.startDatePublishIndex)}
          col={3}
        />
        <FieldItem
          label='To'
          value={formatDateToDDMMYYYY(parcel?.endDatePublishIndex)}
          col={3}
        />
        {pricingPeriod === 2 ? (
          <FieldItem label='Schema B/L Date' value={parcel?.schemaBL} col={3} />
        ) : null}
      </Row>

      <div className='my-3 pb-3 border-bottom'>
        <div className='border-start border-2 border-primary ps-3'>
          <Label className='fw-semibold small text-dark mb-1'>
            Information for Pricing
          </Label>
          {parcel.notesForPricing ? (
            <div className='html-content-panel'>
              <div
                className='html-content-body'
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(parcel.notesForPricing),
                }}
              />
            </div>
          ) : (
            <p className='mb-0 text-muted small'>-</p>
          )}
        </div>
      </div>
    </>
  );
};

export default ParcelField;
